<div class="dropdown-container" [style.width]="dropDownWidth">
  <div class="dropdown-button" [class.disabled]="isLoading" [class.open]="isDropdownOpen()" (click)="toggleDropdown()">
    <span class="dropdown-text" [class.placeholder]="!selectedValue">
      {{ getDisplayText() }}
    </span>
    <img src="assets/icons/keyboard_arrow_down.svg" alt="dropdown arrow" class="dropdown-arrow"
      [class.rotated]="isDropdownOpen()">
  </div>

  <div class="dropdown-list" *ngIf="isDropdownOpen() && !isLoading" [@dropdownAnimation]>
    <div class="list-items">
      <div class="list-item" *ngFor="let item of contentList" (click)="selectItem(item)"
        [class.selected]="selectedValue?.value === item.value">
        <div class="item-content">
          <span class="item-text">{{ item.label }}</span>
          <span *ngIf="item.status === 'published'" class="status-tag">
            Published
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
    <span>Loading versions...</span>
  </div>
</div>
